import { render } from "./SelfAuth.vue?vue&type=template&id=4b267b46&scoped=true"
const script = {}

import "./SelfAuth.vue?vue&type=style&index=0&id=4b267b46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b267b46"]])

export default __exports__